/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Non_ProfitInputs */

const en_non_profit = /** @type {(inputs: Non_ProfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit`)
};

const es_non_profit = /** @type {(inputs: Non_ProfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin Fines de Lucro`)
};

const fr_non_profit = /** @type {(inputs: Non_ProfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À but non lucratif`)
};

const de_non_profit = /** @type {(inputs: Non_ProfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinnützig`)
};

const id_non_profit = /** @type {(inputs: Non_ProfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit`)
};

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const ja_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const zh_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const ar_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const it_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const ru_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const pt_non_profit = en_non_profit;

/** @type {(inputs: Non_ProfitInputs) => LocalizedString} */
const ko_non_profit = en_non_profit;

/**
* | output |
* | --- |
* | "Non-Profit" |
*
* @param {Non_ProfitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const non_profit = /** @type {((inputs?: Non_ProfitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Non_ProfitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_non_profit(inputs)
	if (locale === "es") return es_non_profit(inputs)
	if (locale === "fr") return fr_non_profit(inputs)
	if (locale === "de") return de_non_profit(inputs)
	if (locale === "ja") return ja_non_profit(inputs)
	if (locale === "zh") return zh_non_profit(inputs)
	if (locale === "ar") return ar_non_profit(inputs)
	if (locale === "id") return id_non_profit(inputs)
	if (locale === "it") return it_non_profit(inputs)
	if (locale === "ru") return ru_non_profit(inputs)
	if (locale === "pt") return pt_non_profit(inputs)
	return ko_non_profit(inputs)
});